import { render } from "./InputsInformations.vue?vue&type=template&id=81e31f6e&scoped=true"
import script from "./InputsInformations.vue?vue&type=script&lang=js"
export * from "./InputsInformations.vue?vue&type=script&lang=js"

import "./InputsInformations.vue?vue&type=style&index=0&id=81e31f6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e31f6e"]])

export default __exports__